import { useRouter } from "src/helpers"; // import lodash from 'lodash';
// import deepdash from 'deepdash-es';

import {
    withHookForContent,
    withUpdateContent,
} from "src/modules/content/operations";
import { compose } from "src/helpers";

import EditView from "./component";

const Edit = (props) => {
    const { updateContent } = props;
    const router = useRouter();

    const onFinish = async (values: any) => {
        await updateContent(values);
        router.push("/collection/content");
    };

    const onFinishFailed = (errorInfo: any) => {
        console.log("Failed:", errorInfo);
    };

    return (
        <EditView
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            {...props}
        />
    );
};

export default compose(withHookForContent, withUpdateContent)(Edit);
